export class NoteType {
    private _code: string = "";
    private _text: string = "";

    constructor(code: string, text: string) {
        this._code = code;
        this._text = text;
    }

    get code() {
        return this._code;
    }

    get text() {
        return this._text;
    }
}
